module.exports = __webpack_public_path__ + "static/media/IMG_026.b04aaf22.JPG";